const LS_GUEST_ATTEMPT_ID = 'eduquiz_guest_attempt_id';

function makeGuestId() {
  const a = Math.random().toString(36).slice(2, 10);
  const b = Date.now().toString(36);
  return `guest:${b}${a}`;
}

export function getOrCreateGuestAttemptId() {
  try {
    const cur = localStorage.getItem(LS_GUEST_ATTEMPT_ID);
    if (cur && cur.startsWith('guest:')) return cur;
    const next = makeGuestId();
    localStorage.setItem(LS_GUEST_ATTEMPT_ID, next);
    return next;
  } catch {
    return makeGuestId();
  }
}

export function getGuestAttemptId() {
  try {
    const cur = localStorage.getItem(LS_GUEST_ATTEMPT_ID);
    if (cur && cur.startsWith('guest:')) return cur;
    return '';
  } catch {
    return '';
  }
}
